'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    init();
    stickyMenu();
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $mainMenu = (0, _jquery2.default)('#mainMenu', document);

function stickyMenu() {
    (0, _jquery2.default)('.header__bottom').stick_in_parent({
        parent: 'body',
        sticky_class: 'header-sticky',
        inner_scrolling: false
    });
}
function init() {
    if ($mainMenu.length === 0) return;
    var mainMenuWidth = void 0;
    var anotherElmWidth = (0, _jquery2.default)('.h-b__right').outerWidth();
    var wrapWidth = $mainMenu.closest('div').width();
    var $menuWrap = $mainMenu.closest('nav');

    // set actual with
    if ($mainMenu.data('width') != undefined) {
        mainMenuWidth = $mainMenu.data('width');
    } else {
        mainMenuWidth = $mainMenu.outerWidth();
        $mainMenu.data('width', mainMenuWidth);
    }

    if (mainMenuWidth + anotherElmWidth > wrapWidth) {
        $menuWrap.addClass('menu__wrap--mobile');

        // for nice animation
        setTimeout(function () {
            $mainMenu.addClass('menu--transition');
        }, 10);
    } else {
        $menuWrap.removeClass('menu__wrap--mobile');

        // for nice animation
        setTimeout(function () {
            $mainMenu.removeClass('menu--transition');
        }, 10);
    }

    // make menu visible after javascript up
    (0, _jquery2.default)('.h-b__inner').css('opacity', 1);
}

(0, _jquery2.default)(window).on('resize', _jquery2.default.debounce(200, function () {
    init();
}));

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/menuResponsive.js
// module id = 408
// module chunks = 0 2